
<!-- <section class="loader-container"> -->
<section class="loader-container"  *ngIf="isLoading$ | async">
 <img
    src="/assets/img/Logo2.svg"
    class="scale-class"
    style="height: 10vh"
    alt=""
  />
</section>
